// import React, { useState, useEffect, useMemo } from 'react';
// import { Line } from 'react-chartjs-2'
// import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
// import './GraphDistances.css'

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


// const GraphDistances= ({ distances = [], highlightIndex }) => {

//   const [points, setPoints] = useState([]);



//   useEffect(() => {
//     if (distances) {
//     //   console.log('[GraphDistances] Données formatées reçues, traitement...');
//       generatePoints(distances);
//     }
//     else{
//         console.log('[GraphDistances] ERROR : distances = ', distances);
//     }
//   }, [distances]);



//   const generatePoints = (data) => {
//     // console.log('[GraphDistances] (generatePoints) data : ', data);
//     const yValues = data.map((item) => parseFloat(item));
//     // console.log('[GraphDistances] (generatePoints) yValues : ', yValues);
//     const generatedPoints = yValues.map((y, index) => ({ x: index + 1, y })); // Add 1 to index
//     // console.log('[GraphDistances] (generatePoints) generatedPoints : ', generatedPoints);
//     setPoints(generatedPoints);
//   };


//     // Configuration du graphique
//     const chartData = {
//         datasets: [
//         {
//             label: 'Distances',
//             data: points, 
//             borderColor: 'rgba(75,192,192,1)',
//             backgroundColor: 'rgba(75,192,192,0.2)',
//             fill: true, // Remplir la zone sous la courbe
//             tension: 0.1,
//             pointBackgroundColor: points.map((_, i) =>
//                 i === highlightIndex ? 'red' : 'rgba(75,192,192,1)'
//             ),
//             pointRadius: points.map((_, i) =>
//                 i === highlightIndex ? 6 : 3
//             ),
//         },
//         ],
//     };

//     // Options de configuration du graphique
//     const options = {
//         responsive: true,
//         scales: {
//             x: {
//                 type: 'linear', // Utiliser une échelle linéaire pour l'axe X
//                 position: 'bottom',
//                 min: 1, // Set minimum value to 1
//                 ticks: {
//                     stepSize: 1, // Pas d'intervalle fixe
//                     // callback: function(value) {
//                     //     return Math.floor(value); // Ensure whole numbers
//                     // }
//                 },
//             },
//             y: {
//                 beginAtZero: false,
//             },
//         },
//         plugins: {
//             legend: {
//                 position: 'top',
//             },
//             tooltip: {
//                 callbacks: {
//                     label: function (tooltipItem) {
//                         return `Distance: ${tooltipItem.raw.y.toFixed(4)}`; // 4 chiffres après la virgule
//                     },
//                 },
//             },
//         },
//     };



//     return (
//         <div className="graph-container">
//             <h2>Distance graph</h2>
//             <Line data={chartData} options={options} />
//         </div>
//     );
// };

// export default GraphDistances;










// import Plot from 'react-plotly.js';

// const GraphDistances = ({ distances = [], highlightIndex, names = [] }) => {
//   const x = Array.from({ length: distances.length }, (_, i) => i + 1);
//   const y = distances.map(Number);

//   // Pour surligner le point courant
// //   const markerColors = y.map((_, i) => i === highlightIndex ? 'red' : 'rgba(75,192,192,1)');
// //   const markerColors = y.map((_, i) => i === highlightIndex ? 'red' : 'rgba(0,123,255,0.8)'); // bleu foncé et opaque
// // const markerColors = y.map((_, i) => i === highlightIndex ? 'red' : 'black');
// const markerColors = y.map((_, i) => i === highlightIndex ? 'red' : 'rgba(0,0,0,0.2)');
// // const markerSizes = y.map((_, i) => i === highlightIndex ? 10 : 6);
// const markerSizes = y.map((_, i) => i === highlightIndex ? 10 : 2); // 2 au lieu de 6
//   return (
//     <Plot
//         data={[
//             {
//             x,
//             y,
//             text: names,
//             type: 'scattergl',
//             mode: 'markers',
//             marker: {
//                 color: markerColors,
//                 size: markerSizes,
//             },
//             line: { color: 'rgba(0,0,0,0.2)' },
//             hovertemplate: '%{text}<br>Distance: %{y:.4f}<extra></extra>',
//             },
//         ]}
//         layout={{
//             title: 'Distance graph',
//             xaxis: { title: 'Index' },
//             yaxis: { title: 'Distance' },
//             height: 400,
//             plot_bgcolor: '#fff', // fond blanc
//             paper_bgcolor: '#fff',
//         }}
//         config={{ responsive: true }}
//         style={{ width: '100%' }}
//     />
//   );
// };

// export default GraphDistances;




import Plot from 'react-plotly.js';

const MAX_POINTS = 1000;

const GraphDistances = ({ distances = [], highlightIndex = 0, names = [] }) => {
  const total = distances.length;

  let start = 0;
  let end = total;

  if (total > MAX_POINTS) {
    // Centrer sur le point sélectionné
    start = Math.max(0, highlightIndex - Math.floor(MAX_POINTS / 2));
    end = start + MAX_POINTS;
    // Si on dépasse la fin, on compense au début
    if (end > total) {
      end = total;
      start = Math.max(0, end - MAX_POINTS);
    }
  }

  // Découpe les données à afficher
  const x = Array.from({ length: end - start }, (_, i) => start + i + 1);
  const y = distances.slice(start, end).map(Number);
  const displayNames = names.slice(start, end);

  // Calcul du nouvel index du point sélectionné dans la fenêtre affichée
  const localHighlightIndex = highlightIndex - start;

  const markerColors = y.map((_, i) => i === localHighlightIndex ? 'red' : 'black');
  const markerSizes = y.map((_, i) => i === localHighlightIndex ? 20 : 8);

  console.log('displayNames', displayNames);

  return (
    <Plot
      data={[
        {
          x,
          y,
          text: displayNames,
          type: 'scattergl',
          mode: 'markers',
          marker: {
            color: markerColors,
            size: markerSizes,
          },
          line: { color: 'rgba(0,0,0,0.2)' },
          // hovertemplate: '%{text}<br>Distance: %{y:.4f}<extra></extra>',
          hovertemplate: 'Paire: %{x}<br>Distance: %{y:.4f}<extra></extra>',          
        },
      ]}
      layout={{
        title: { text: 'Distance graph', font: { size: 22 } },
        xaxis: {
          title: 'Index',
          showline: true,
          showgrid: true,
          zeroline: true,
          linecolor: '#444',
          linewidth: 2,
          mirror: true,
        },
        yaxis: {
          title: 'Distance',
          showline: true,
          showgrid: true,
          zeroline: true,
          linecolor: '#444',
          linewidth: 2,
          mirror: true,
        },
        height: 400,
        plot_bgcolor: '#fff',
        paper_bgcolor: '#fff',
        margin: { t: 60, l: 60, r: 30, b: 60 },
      }}
      config={{ responsive: true }}
      style={{ width: '100%' }}
    />
  );
};

export default GraphDistances;
